export const quotes = [
  {
    text: "Жизнь — это то, что с тобой происходит, пока ты строишь планы.",
    author: "Джон Леннон"
  },
  {
    text: "Будущее принадлежит тем, кто верит в красоту своих мечтаний.",
    author: "Элеонора Рузвельт"
  },
  {
    text: "Единственный способ делать великую работу — это любить то, что ты делаешь.",
    author: "Стив Джобс"
  },
  {
    text: "Образование — самое мощное оружие, которое можно использовать, чтобы изменить мир.",
    author: "Нельсон Мандела"
  },
  {
    text: "Твоё время ограничено, не трать его, живя чужой жизнью.",
    author: "Стив Джобс"
  },
  {
    text: "Вдохновение существует, но оно должно застать тебя за работой.",
    author: "Пабло Пикассо"
  },
  {
    text: "В середине трудности кроется возможность.",
    author: "Альберт Эйнштейн"
  },
  {
    text: "Успех — это переход от неудачи к неудаче без потери энтузиазма.",
    author: "Уинстон Черчилль"
  },
  {
    text: "Счастье — это не готовая вещь. Оно приходит от твоих собственных действий.",
    author: "Далай-лама"
  },
  {
    text: "Жизнь на 10% состоит из того, что с тобой происходит, и на 90% — из того, как ты на это реагируешь.",
    author: "Чарльз Суиндолл"
  },
  {
    text: "Лучшее время посадить дерево было 20 лет назад. Второе лучшее время — сейчас.",
    author: "Китайская пословица"
  },
  {
    text: "Выживает не самый сильный, не самый умный, а тот, кто лучше всех приспосабливается к изменениям.",
    author: "Чарльз Дарвин"
  },
  {
    text: "Разница между обычным и необычным — в том маленьком 'экстра'.",
    author: "Джимми Джонсон"
  },
  {
    text: "Неудача — это просто возможность начать снова, на этот раз более разумно.",
    author: "Генри Форд"
  },
  {
    text: "Границы, как и страх, часто являются лишь иллюзией.",
    author: "Майкл Джордан"
  },
  {
    text: "Воображение важнее знания.",
    author: "Альберт Эйнштейн"
  },
  {
    text: "Жить — самая редкая вещь в мире. Большинство людей просто существуют.",
    author: "Оскар Уайльд"
  },
  {
    text: "Не жди идеального момента, возьми момент и сделай его идеальным.",
    author: "Пословица"
  },
  {
    text: "Ты не можешь исчерпать творчество. Чем больше ты его используешь, тем больше у тебя его становится.",
    author: "Майя Анжелу"
  },
  {
    text: "Что нас не убивает, делает нас сильнее.",
    author: "Фридрих Ницше"
  }
]